import React from 'react'
import {Alert} from 'reactstrap'
import AdminIcon from 'react-icons/lib/fa/cogs'
import { environment } from '../../api'

class AdminLinkBubble extends React.Component {
    constructor(props) {
        super(props)
        const {url, modelName, className} = props
        this.state = {
            url,
            modelName,
            className,
        }
    }

    componentWillReceiveProps(nextProps) {
        const {url, modelName, className} = nextProps
        this.setState({
            url,
            modelName,
            className,
        })
    }

    render() {
        let {url, modelName, className} = this.state
        return (<a href={environment.ADMIN_URL + url}>
                <Alert color="light" className={`text-center ${className}`}>
                    <p className=""><AdminIcon className="mr-2 half-opacity"/>View This {modelName} In Admin</p>
                </Alert>
        </a>)
    }
}

export default AdminLinkBubble


// WEBPACK FOOTER //
// ./src/components/ui/AdminLinkBubble.js